import PortfolioList from "../portfoliolist/PortfolioList";
import "./portfolio.scss";
import React, { useState, useEffect } from "react";

import {
  featuredPortfolio,
  webPortfolio,
  mobilePortfolio,
} from "../../data.js";

export default function Portfolio({darkMode}) {
  const list = [
    {
      id: "featured",
      title: "Featured",
    },
    {
      id: "web",
      title: "Web App",
    },
    {
      id: "mobile",
      title: "Mobile App",
    },
  ];

  const [selected, setSelected] = useState("featured");
  const [data, setData] = useState([]);

  useEffect(() => {
    switch (selected) {
      case "featured":
        setData(featuredPortfolio);
        break;
      case "web":
        setData(webPortfolio);
        break;
      case "mobile":
        setData(mobilePortfolio);
        break;
      default:
        setData(featuredPortfolio);
    }
  }, [selected]);

  return (
    <div className={`portfolio ${darkMode? 'light': 'dark'}`} id="portfolio">
      <h1>Portfolio</h1>
      <ul>
        {list.map((item) => (
          <PortfolioList
            title={item.title}
            active={selected === item.id}
            setSelected={setSelected}
            id={item.id}
          />
        ))}
      </ul>
      <div className="container">
        {data.map((d) => (
          <div className="item" onClick={()=>{
            window.open(d.link, "_blank")
          }}>
            {/* <img src={d.img} alt="" /> */}
            <h3>{d.title}</h3>
          </div>
        ))}
      </div>
      <a href="#about">
        <img src="assets/down.png" alt="" />
      </a>
      <a href="#intro" className="arrowUp">
        <img src="assets/down.png" alt="" />
      </a>
    </div>
  );
}
